import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/header';
import Footer from './components/Footer';
import Home from './pages/home';
import About from './pages/about';
import Product from './pages/product';
import Detail from './pages/detail';
import ScrollTop from './components/ScrollTop';

const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Product />} />
        <Route path="/product/:title" element={<Detail />} />
      </Routes>
      <Footer />
      <ScrollTop />
    </BrowserRouter>
  );
};

export default App;
